<template>
  <div>

    <!-- Main Row -->
    <div class="row">

      <!-- Form -->
      <div class="col-md-12">
        <Card :title="'Tambah Tipe Remunerasi'">
          <template v-slot:body>
            <Form
              :form="form"
              :route="'remuneration-types'"
            />
          </template>
        </Card>
      </div>

    </div>

  </div>
</template>

<script>

import Card from "@/view/content/Card.vue";
import Form from '@/component/masters/remuneration-types/Form.vue'
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

export default {

  data() {
    return {
      form: {
        name: '',
        description: '',
        is_tax:false,
      },
    };
  },

  components: {
    Card,
    Form
  },

  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Tipe Remunerasi", route: "" },
      { title: "Daftar Tipe Remunerasi", route: "/masters/remuneration-types/list" },
      { title: "Tambah" },
    ])
  },

}

</script>